// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { ListItemFactory } from "@app/shared";
import { DepartmentModel, DocumentModel, MenuModel, ProjectPropertyDto } from "@app/catalog";
import { CategoryModel } from "@app/catalog";


export class ProjectPropertyModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public categories: WritableSignal<CategoryModel[]>;
    public documents: WritableSignal<DocumentModel[]>;
    public departments: WritableSignal<DepartmentModel[]>;
    public hasImageError: WritableSignal<boolean>;
    public menus: WritableSignal<MenuModel>;

    constructor()
    {
        this.name = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);
        this.categories = signal<CategoryModel[]>([]);
        this.documents = signal<DocumentModel[]>([]);
        this.departments = signal<DepartmentModel[]>([]);
        this.hasImageError = signal<boolean>(false);
        this.menus = signal<MenuModel>(null);
    }

    public handleImageError() {
        this.hasImageError.set(true);
    }

    public static fromDto(dto: ProjectPropertyDto)
    {
        let project = new ProjectPropertyModel();

        project.id = dto.id;
        project.name.set(dto.name);
        project.thumbnailUrl.set(dto.thumbnailUrl);
        project.documents.set((dto.documents || []).map(doc => DocumentModel.fromDto(doc)));
        project.departments.set((dto.departments || []).map(dept => DepartmentModel.fromDto(dept)));

        
        //TODO:DIW:At somepoint the selected categories could be passed in so CategoryModel.fromDto can have isChecked set properly.
        project.categories.set(dto.categories.map(cat=>CategoryModel.fromDto(cat, false)));
        project.menus.set(MenuModel.fromDto(dto.menus));    

        return project;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProjectPropertyModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProjectPropertyModel>(this.name, this.id, this, selected);

}
